const About = () => {
  return (
    <div className="App">
      <div className="Content">
        <h2>About</h2>
        Im Aufbau...
      </div>
    </div>
  );
};

export default About;
